import { Box, HStack, IconButton, Tooltip } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { REACTION_EMOJIS, REACTION_LABELS, type ReactionType } from '@/types/social';

const bounceAnimation = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.3); }
`;

const reactions: ReactionType[] = ['fire', 'yummy', 'perfect', 'craving', 'love'];

interface ReactionPickerProps {
  onSelect: (reaction: ReactionType) => void;
  currentReaction?: ReactionType | null;
  isLoading?: boolean;
}

export const ReactionPicker = ({ onSelect, currentReaction, isLoading }: ReactionPickerProps) => {
  return (
    <Box
      bg="var(--card-bg)"
      borderRadius="full"
      boxShadow="0 4px 20px var(--color-overlay-20)"
      border="1px solid"
      borderColor="var(--color-overlay-08)"
      p={2}
    >
      <HStack spacing={1}>
        {reactions.map((reaction) => {
          const isSelected = currentReaction === reaction;
          return (
            <Tooltip
              key={reaction}
              label={REACTION_LABELS[reaction]}
              placement="top"
              hasArrow
              bg="gray.800"
              fontSize="xs"
            >
              <IconButton
                aria-label={REACTION_LABELS[reaction]}
                variant="ghost"
                size="md"
                fontSize="xl"
                isDisabled={isLoading}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(reaction);
                }}
                _hover={{
                  bg: 'transparent',
                  animation: `${bounceAnimation} 0.3s ease-in-out`,
                  transform: 'scale(1.2)',
                }}
                _active={{ transform: 'scale(0.9)' }}
                sx={{
                  minW: '40px',
                  h: '40px',
                  borderRadius: 'full',
                  bg: isSelected ? 'var(--color-purple-50)' : 'transparent',
                  border: isSelected ? '2px solid' : 'none',
                  borderColor: isSelected ? 'var(--color-purple-400)' : 'transparent',
                }}
              >
                {REACTION_EMOJIS[reaction]}
              </IconButton>
            </Tooltip>
          );
        })}
      </HStack>
    </Box>
  );
};
